import { API } from "@aws-amplify/api";

interface HistoryEntry {
  content: string;
  callId: string;
}

interface ConversationHistory {
  [key: string]: HistoryEntry;
}

class Conversation {
  id: string;
  title: string;
  history: ConversationHistory;
  createdAt: Date;
  updatedAt: Date;
  agentId?: string;
  status?: string;

  constructor(agentId :string, id?: string, title?: string, history?: ConversationHistory) {
    this.id = id || crypto.randomUUID();
    this.title = title || "New Conversation";
    this.history = history || {};
    this.createdAt = new Date();
    this.updatedAt = new Date();
    this.agentId = agentId;
    this.status = "active";
  }

  replaceHistory(history: ConversationHistory): void {
    this.history = history;
    this.updatedAt = new Date();
  }

  updateTitle(newTitle: string): void {
    this.title = newTitle;
    this.updatedAt = new Date();
  }

  updateStatus(newStatus: string): void {
    this.status = newStatus;
    this.updatedAt = new Date();
  }

  load = async (token: any) => {
    try {
      const result = await API.get("eventapi", "/conversationCalls", {
        queryStringParameters: {
          token: token,
          conversationId: this.id,
        },
      });

      if (result && result.data) {
        const callData = JSON.parse(result.data);
        const history: ConversationHistory = {};

        for (const call of callData) {
          history[call.prompt] = {
            content: call.response,
            callId: call.id,
          };
        }

        this.replaceHistory(history);
      }
    } catch (error) {
      console.error("Error fetching calls:", error);
    }
  };
}

export default Conversation;
export type { HistoryEntry, ConversationHistory };